var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 100 100",
    fill: "#005578",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_2599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5414 0H7.29141C3.27072 0 0 3.27072 0 7.29141V26.0414C0 30.0629 3.27072 33.3336 7.29141 33.3336H38.5414C42.5629 33.3336 45.8336 30.0629 45.8336 26.0414V7.29141C45.8336 3.27072 42.5629 0 38.5414 0Z",
    fill: "#005578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5414 41.6664H7.29141C3.27072 41.6664 0 44.9371 0 48.9586V92.7086C0 96.7292 3.27072 100 7.29141 100H38.5414C42.5629 100 45.8336 96.7292 45.8336 92.7086V48.9586C45.8336 44.9371 42.5629 41.6664 38.5414 41.6664V41.6664Z",
    fill: "#005578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7086 66.6664H61.4586C57.4371 66.6664 54.1664 69.9371 54.1664 73.9586V92.7086C54.1664 96.7292 57.4371 100 61.4586 100H92.7086C96.7293 100 100 96.7292 100 92.7086V73.9586C100 69.9371 96.7293 66.6664 92.7086 66.6664V66.6664Z",
    fill: "#005578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7086 0H61.4586C57.4371 0 54.1664 3.27072 54.1664 7.29141V51.0414C54.1664 55.0629 57.4371 58.3336 61.4586 58.3336H92.7086C96.7293 58.3336 100 55.0629 100 51.0414V7.29141C100 3.27072 96.7293 0 92.7086 0V0Z",
    fill: "#005578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_2599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#005578"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlue);
export default __webpack_public_path__ + "static/media/DashboardBlue.9cb1b326bae5679e9c4e9249a530366e.svg";
export { ForwardRef as ReactComponent };